import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import { COLUMN_WIDTH } from '~/web-frontend-core/api/const/base';
export default class OutcomesTables extends Subscribtion {
    constructor(width = COLUMN_WIDTH.MEDIUM) {
        super();
        this.width = width;
        this.data = new Map();
        /** Избранные таблицы общие между матчами */
        this.favoriteTables = new Map();
        this.sportID = {};
        this.select = this.select.bind(this);
        this.favorite = this.favorite.bind(this);
        this.getFavoriteTables = this.getFavoriteTables.bind(this);
    }
    getData(matchID) {
        return this.data.get(Number(matchID)) || null;
    }
    /**
     * Обновление таблицы доп.росписи
     * @example
     * ```
     *    tables.update(matchID, {
     *       [categoryID]: [[{ "txt": "Двойной шанс", "st": "h" }]],
     *    });
     * ```
     */
    update(matchID, sportID = this.sportID[matchID], { isDisabled }, newData, style, coefs, additionalOdds, expandedTables) {
        if ((newData === null || style === null ||
            typeof coefs !== 'undefined') && Object.keys(coefs).length === 0) {
            this.clearGame(matchID);
            this.notify(matchID);
            return;
        }
        const data = this.data.get(matchID);
        if (!data) {
            const favoriteTables = this.favoriteTables.get(sportID);
            const foldedTables = [];
            const tables = (newData || []).reduce((d, { id, rows }, order) => {
                const visibleOnWidth = style && style[id].vis;
                const isVisible = visibleOnWidth ? visibleOnWidth === this.width : true;
                const columnWidths = style && style[id].colWidths || [];
                const isFolded = expandedTables && expandedTables.expand.length !== 0 && expandedTables.expand.indexOf(id) === -1 || false;
                if (isFolded) {
                    foldedTables.push(id);
                }
                d[id] = {
                    isFavorite: favoriteTables && favoriteTables.has(id),
                    isSelected: !!style && style[id].isSelected,
                    visibleOnWidth,
                    columnWidths,
                    isVisible,
                    isFolded,
                    // order,
                    rows,
                };
                return d;
            }, {});
            while ((newData || []).length - foldedTables.length < (expandedTables && expandedTables.minCount || 1) && foldedTables.length !== 0) {
                tables[foldedTables.shift()].isFolded = false;
            }
            this.sportID[matchID] = sportID;
            if (!favoriteTables) {
                this.favoriteTables.set(sportID, new Set());
            }
            this.data.set(matchID, {
                additionalOdds: additionalOdds || [],
                isDisabled: !!isDisabled,
                foldedTables: new Set(),
                coefs: coefs || {},
                tables,
            });
            this.notify(matchID);
            return;
        }
        this.updateTables(data, newData, style);
        Object.assign(data.coefs, coefs);
        data.additionalOdds = additionalOdds || data.additionalOdds;
        if (typeof isDisabled !== 'undefined') {
            data.isDisabled = isDisabled;
        }
        this.notify(matchID);
    }
    updateTables(data, newData = [], style = {}) {
        if (!(newData === null || newData === void 0 ? void 0 : newData.length))
            return; // чтобы предотвратить скрытие таблицы если обновлений нет
        const updated = {};
        (newData || []).forEach(({ id, rows }) => {
            updated[id] = true;
            const visibleOnWidth = style[id].vis;
            const isVisible = visibleOnWidth ? visibleOnWidth === this.width : true;
            if (data.tables[id]) {
                data.tables[id].rows = rows;
                data.tables[id].isVisible = isVisible;
                return;
            }
            const columnWidths = style[id].colWidths || [];
            data.tables[id] = {
                isSelected: !!style[id].isSelected,
                isFavorite: false,
                visibleOnWidth,
                columnWidths,
                isVisible,
                rows,
            };
        });
        const disabledTables = Object.keys(data.tables).filter((id) => !updated[id]);
        disabledTables.forEach((id) => { data.tables[id].isVisible = false; });
    }
    restyle(matchID, style = {}) {
        const data = this.data.get(matchID);
        if (!data) {
            return;
        }
        objectEntries(style).forEach(([id, { colWidths, isSelected, isFavorite, isFolded, isVisible }]) => {
            if (!data.tables[id]) {
                return;
            }
            if (typeof isVisible !== 'undefined') {
                data.tables[id].isVisible = isVisible;
            }
            if (!data.tables[id].isVisible) {
                return;
            }
            if (typeof colWidths !== 'undefined') {
                data.tables[id].columnWidths = colWidths;
            }
            if (typeof isSelected !== 'undefined') {
                data.tables[id].isSelected = isSelected;
            }
            if (typeof isFavorite !== 'undefined') {
                data.tables[id].isFavorite = isFavorite;
            }
            if (typeof isFolded !== 'undefined') {
                data.tables[id].isFolded = isFolded;
            }
        });
        this.notify(matchID);
    }
    setWidth(width) {
        if (this.width === width) {
            return;
        }
        this.width = width;
        for (const [matchID, data] of Array.from(this.data.entries())) {
            const states = objectFromEntries(objectEntries(data.tables)
                .filter(([, { visibleOnWidth }]) => !!visibleOnWidth)
                .map(([tableID, { visibleOnWidth }]) => [tableID, {
                    isVisible: visibleOnWidth === width,
                    isSelected: visibleOnWidth === width
                }]));
            this.restyle(matchID, states);
        }
    }
    //#region select
    select(matchID, tablesIDs, isSelected) {
        const tables = tablesIDs.length !== 0 ? tablesIDs : Object.keys((this.getData(matchID) || {}).tables || {});
        const state = objectFromEntries(tables.map((tableID) => [tableID, { isSelected }]));
        this.restyle(matchID, state);
    }
    //#endregion select
    //#region favorite
    favorite(matchID, tablesIDs, isFavorite) {
        if (!this.getData(matchID)) {
            return;
        }
        const sportID = this.sportID[matchID];
        const favoriteTables = this.favoriteTables.get(sportID);
        const action = isFavorite ?
            (tableID) => favoriteTables.add(tableID) :
            (tableID) => favoriteTables.delete(tableID);
        tablesIDs.forEach(action);
        const state = objectFromEntries(tablesIDs.map((tableID) => [tableID, { isFavorite }]));
        this.restyle(matchID, state);
    }
    getFavoriteTables(sportID, matchID) {
        const tables = (this.getData(matchID) || {}).tables || {};
        const favoriteTables = this.favoriteTables.get(sportID);
        return Array.from(favoriteTables && favoriteTables.values() || [])
            .filter((tableID) => tableID in tables);
    }
    //#endregion favorite
    //#region fold
    fold(matchID, tableIDs, isFolded = true) {
        const data = this.getData(matchID);
        if (!data) {
            throw new Error('No data to fold tables');
        }
        const tables = tableIDs || Object.keys(data.tables);
        const action = isFolded ?
            (tableID) => data.foldedTables.add(tableID) :
            (tableID) => data.foldedTables.delete(tableID);
        tables.forEach(action);
        const style = objectFromEntries(tables.map((tableID) => [tableID, { isFolded }]));
        this.restyle(matchID, style);
    }
    isAllUnfolded(matchID) {
        const data = this.getData(matchID);
        return !data || data.foldedTables.size === 0;
    }
    //#endregion fold
    //#region clean
    clear() {
        this.sportID = {};
        this.data.clear();
        this.notify();
    }
    clearGame(matchID) {
        this.data.set(matchID, {
            foldedTables: new Set(),
            isDisabled: false,
            additionalOdds: [],
            tables: {},
            coefs: {}
        });
        this.notify(matchID);
    }
    deleteGame(matchID) {
        this.data.delete(matchID);
        this.notify(matchID);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes/additional/Tables.js